import {createSlice} from '@reduxjs/toolkit'

const Editable = createSlice({
    name:"Editable",
    initialState:{
        editable:null
    },
    reducers:{
        setId:(state,action)=>{
            console.log(action)
            console.log("consoled inside the store")
            state.editable = action.payload
            console.log(state.id)
        },
        removeId:(state,action)=>{
            console.log(action)
            state.editable = null
            
        },
    }
})

export const {setId,removeId} = Editable.actions
export default Editable.reducer